import { createToastInterface } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

const options = {
  hideProgressBar: true
}

const toast = createToastInterface(options)
export default toast
